import React, { useContext, useCallback, ReactElement, useRef } from 'react';
import { useNavigate, useLocation, useParams } from "react-router";

import { useEffect, useState } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import { useUserContext } from '../../contexts/user-context';
import { EContractDialog } from './panes/EContractDialog';
import { ExchangeRatesContextProvider } from '../../contexts/exchange-rates-context';
import { Box, Tab, Tabs, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import WaitSpinner from "../../components/wait-spinner";
import { Campaign } from "../../generated/graphql";
import { BookmarkAdd, BookmarkRemove } from "@mui/icons-material";
import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack';
import { useDaybookContext } from './../../contexts/Daybook/DayBookContext';
import GQLChanges from '../../utils/graphql-changes';
import { fieldMappings } from './fieldMappings';
//import { ChallengeEmailDialog } from './ChallengeEmail';

// todo change ERR to be a true object rather than just strings (also requires changing fieldtable)
/*
function tabLabel(label, obj, err) {
    return (obj && obj.length) ? <span className={err ? Classes.INTENT_DANGER : ''}>{label}</span> : <span className="tab-empty">{label}</span>;
}
*/
type tabStatusArgs = {
    label: string,
    hasContent: boolean,
    value: string,
    error: boolean,
    changeTab: any
};

export type CampaignOutletContextValue = {
    initialValues: Campaign
    setTab: (tab: string) => void
    isDirty: boolean
    onChange: any
    setValue: any
    setTransient: any
    transientValues: any
    values: Campaign
    readOnly: boolean
    loading: boolean
    jobRef: string
    errors: any
    updateInitialValues: (Campaign) => void
}

/*
export function CampaignForm({diaForm,tabErrors}) {
    console.log('RENDERING WITH',diaForm);
    return <CampaignFormContent diaForm={diaForm} tabErrors={tabErrors}/>;
}
*/
function TabStatus(props: tabStatusArgs): ReactElement {
    const theme = useTheme();
    /*    let status = (palette)=>palette.text.disabled;
        let typo = (typography)=>typography.fontWeightLight;
        if(props.hasContent) { 
            status = (palette)=>palette.text.primary;
            typo = (typography)=>typography.fontWeightNormal;
        }
        if(props.error) { status =  (palette)=>palette.error.main; }*/
    const style = {
        fontWeight: theme.typography.fontWeightLight,
        color: theme.palette.text.disabled
    };
    if (props.hasContent) {
        style.fontWeight = theme.typography.fontWeightNormal;
        style.color = '#000';//theme.palette.text.primary;
    }
    if (props.error) {
        style.color = theme.palette.error.main;
    }
    return <Tab key={props.value} value={props.value} onClick={(evt) => props.changeTab(evt, props.value)} label={props.label} style={style} />;
}

// eslint-disable-next-line react/display-name
export const CampaignForm = ({ diaForm, tabErrors, waiting }) => {
    const { transientValues, setTransient, initialValues, values, updateInitialValues, errors, setValue, handleSubmit, onChange, isDirty, status } = diaForm;
    const tabContainer = useRef();
    const id = values.id;
    const [isDuplicate, setIsDuplicate] = useState(false);
    const isNew = (id === 'new' || isDuplicate);
    const [showEContract, setShowEcontract] = useState(false);
    const [showChallengeDialog, setShowChallengeDialog] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { id: urlId } = useParams();
    const toolbarContext = useContext(ToolbarContext);
    const baseUrl = '/campaigns/';
    const [tab, setTab] = useState('');
    const [tabHeight, setTabHeight] = useState(480);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const daybook = useDaybookContext();
    useEffect(() => {
        if (id) {
            setIsDuplicate(false);
        }
    }, [id]);
    const changeTab = useCallback((evt, newTab) => {
        if (status != 'ready') return;
        navigate('/campaigns/' + (isNew ? 'new' : values.job_reference) + '/' + newTab + (location.search ? location.search : ''), { replace: true });
    }, [location.search, id, status]);
    const [currencyObj, setCurrencyObj] = useState({
        currencyGlyph: values?.currency ? values.currency.glyph : '£',
        options: values?.currencies ? [...values.currencies] : []
    });
    const userContext = useUserContext();
    React.useEffect(() => {
        setCurrencyObj({
            defaultCurrency: values.currency ? Object.assign({}, values.currency) : null,
            options: values.currencies ? [...values.currencies] : []
        });
    }, [values.currency, values.currencies]);

    useEffect(() => {
        if (!tabContainer?.current) {
            return;
        }
        const h = tabContainer?.current?.clientHeight;
        setTabHeight(h);
    }, [tabContainer.current]);

    useEffect(() => {
        if (values?.is_locked && !userContext.hasPermission('campaigns.ignore_lock')) {
          enqueueSnackbar(<span>This campaign is locked and cannot be edited. <br/>Please contact distribution.</span>, { variant: 'warning' });
        }
    }, [values?.is_locked]);      

    const readOnly = !userContext.hasPermission('campaigns.edit') || (values?.is_locked && !userContext.hasPermission('campaigns.ignore_lock'));
    const doSave = () => {
        console.log('CampaignForm doSave?');
        handleSubmit();
    };
    const doneEContract = () => {
        setShowEcontract(false);
    }
    const addToShortcuts = () => {
        userContext.addToShortcuts(values.id);
    };
    const removeFromShortcuts = () => {
        userContext.removeFromShortcuts(values.id);
    };
    const eContract = () => {
        setShowEcontract(true);
    }
    const createDuplicate = async () => {
        setIsDuplicate(true);
    };
    const toggleLock = () => {
        const locking = !values?.is_locked;    
        setValue('is_locked', locking);
        setValue('manually_unlocked', !locking); // if locked, manually_unlocked is false
    
        enqueueSnackbar(
            locking ? 'Campaign locked' : 'Campaign unlocked',
            { variant: 'info' }
        );    
    };
    /*const generateChallengeEmail = useCallback(() => {
        setShowChallengeDialog(true);
    },[]);
    const doneChallenge = () => {
        setShowChallengeDialog(false);
    }*/
    useEffect(() => {
        console.log('SETTOOLBAR', 'UE1', isNew, diaForm.status, waiting);
        const buttons = [];
        let shortListed = false;
        if (!waiting) {
            if (!isNew) {
                userContext.user.campaignShortcuts.forEach((val) => {
                    if (id === val.id) {
                        shortListed = true;
                    }
                });
                if (userContext.hasPermission('campaigns.create_signature')) {
                    buttons.push({
                        type: 'button',
                        icon: <Icon icon="wpf:signature" fontSize={20} />,
                        tooltip: 'Send E-Contract for signature',
                        callback: eContract,
                        label: 'Send E-Contract for signature'
                    });
                }
                if(userContext.hasPermission('campaigns.lock_unlock')){
                    buttons.push({
                        type: 'button',
                        icon: values.is_locked 
                            ? <Icon icon="mdi:lock" fontSize={20} /> 
                            : <Icon icon="mdi:lock-open-variant" fontSize={20} />,
                        tooltip: values.is_locked ? 'Unlock Campaign' : 'Lock Campaign',
                        callback: toggleLock,
                        label: values.is_locked ? 'Unlock Campaign' : 'Lock Campaign'
                    });
                }
                /*buttons.push({
                    type: 'button',
                    icon: <Icon icon="fluent:mail-list-20-regular" fontSize={20}/>,
                    tooltip: 'Send Challenge email',
                    callback: generateChallengeEmail,
                    label: 'Send Challenge email'
                });*/
                if (shortListed) {
                    buttons.push({
                        type: 'button',
                        icon: <BookmarkRemove />,
                        tooltip: 'Remove from Shortcuts',
                        callback: removeFromShortcuts,
                        label: 'Remove from Shortcuts'
                    });
                } else {
                    buttons.push({
                        type: 'button',
                        icon: <BookmarkAdd />,
                        tooltip: 'Add to Shortcuts',
                        callback: addToShortcuts,
                        label: 'Add to Shortcuts'
                    });
                }
            }
            if (!readOnly) {
                buttons.push({
                    type: 'button',
                    icon: 'save',
                    tooltip: 'Save',
                    callback: doSave,
                    label: 'Save',
                    style: 'primary',
                    disabled: !isDirty
                });
                buttons.push({
                    type: 'button',
                    icon: 'duplicate',
                    tooltip: 'Create Duplicate',
                    label: 'Clone Campaign',
                    style: 'secondary',
                    callback: createDuplicate,
                    className: isDirty ? 'intent-primary' : 'intent-warning',
                    disabled: isDirty || isDuplicate
                });
            }
        }

        console.log('SET secondary', values.job_reference);
        toolbarContext.setSecondary({
            primaryUrl: baseUrl,
            title: (!isNew ? '' + values.job_reference + ' / ' + values.name : 'New Campaign'),
            secondary: buttons,
            secondaryUrl: isNew ? 'new' : values.job_reference
        });
    }, [id, waiting, isDirty, isDuplicate, diaForm.values.name, diaForm.status, userContext.user.campaignShortcuts, values.is_locked]);
    const hookSetTab = useCallback((v) => {
        setTab(v);
    }, []);
    useEffect(() => {
        if (isDuplicate && !isNaN(values?.id)) {
            const changes = new GQLChanges(fieldMappings);
            const newValues = changes.clone(values);
            newValues.name += ' (copy)';
            newValues.panelBookings = [];
            newValues.status = "Draft";
            delete newValues?.invoice;
            newValues.authorizationFiles = [];
            newValues.artworkFiles = [];
            delete newValues?.externalPortfolioUrl;
            updateInitialValues({}, null, true);
            setValue('', newValues);
        }
    }, [isDuplicate, isNew, values?.id]);
    const isReadOnly = useCallback((hasPriceImpact) => {
        console.log('readonlycheck', hasPriceImpact, diaForm?.initialValues?.status);
        return readOnly ? readOnly : (hasPriceImpact && diaForm?.initialValues?.status == 'Quoted');
    }, [readOnly, diaForm?.initialValues?.status]);

    if (status != 'ready' && !diaForm.values.id) {
        return <WaitSpinner variant="panel" />;
    }

    const contextValue: CampaignOutletContextValue = {
        setValue: setValue, onChange: onChange, errors: errors, loading: status == 'loading', readOnly: readOnly,
        updateInitialValues: updateInitialValues, jobRef: values?.job_reference, setTab: hookSetTab,
        values: values, initialValues: initialValues, isDirty, isReadOnly,
        transientValues: transientValues,
        setTransient: setTransient
    };



    console.log('CAMPAIGNFORM', { ref: values.job_reference, id: urlId, status: diaForm.status });

    const tabs: JSX.Element[] = [];

    // annoyingly <tab> must be a direct child of Tabs :(
    if (daybook?.useCreativeStudio) {
        if (userContext.hasPermission('campaigns.experiential') && values?.experientials && values.experientials.length > 0) {
            tabs.push(<TabStatus value="experientials" changeTab={changeTab} hasContent={true} error={tabErrors?.experientials} label="Experiential" />)
        }
        if (userContext.hasPermission('campaigns.ambient') && values?.ambients && values.ambients.length > 0) {
            tabs.push(<TabStatus value="ambients" changeTab={changeTab} hasContent={true} error={tabErrors?.ambients} label="Ambient" />);
        }
        if (userContext.hasPermission('campaigns.creative_studio')) {
            tabs.push(<TabStatus value="creative-studio" changeTab={changeTab} hasContent={values?.creativeStudio && values.creativeStudio.length} error={tabErrors?.creativeStudio} label='Creative Studio' />);
        }
    } else {
        if (userContext.hasPermission('campaigns.experiential')) {
            tabs.push(<TabStatus value="experientials" changeTab={changeTab} hasContent={true} error={tabErrors?.experientials} label="Experiential" />)
        }
        if (userContext.hasPermission('campaigns.ambient')) {
            tabs.push(<TabStatus value="ambients" changeTab={changeTab} hasContent={true} error={tabErrors?.ambients} label="Ambient" />);
        }
    }

    return (
        <div style={{ "--tab-height": tabHeight + 'px' } as React.CSSProperties}>
            <ExchangeRatesContextProvider currencyId={values?.currency?.id} options={currencyObj?.options} fixedExchangeRates={values.campaignExchangeRates}>
                {(diaForm.status != 'ready' || (values.job_reference != urlId && !isNew)) &&
                    <WaitSpinner variant="overlay" />
                }
                <EContractDialog isDirty={isDirty} status={values.status} isShown={showEContract} done={doneEContract} reference={values.job_reference} portfolio_hash={values.portfolio_hash}
                    hasContactEmail={!!values.clientCompanyContact?.email}
                />
                {/*
                <ChallengeEmailDialog isShown={showChallengeDialog} done={doneChallenge} reference={values.job_reference}
                />
            */}
                <Box ref={tabContainer} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tab ? tab : 'summary'} onChange={changeTab}>
                        <TabStatus value="overview" changeTab={changeTab} label="Overview" hasContent={true} error={false} />
                        <TabStatus value="summary" changeTab={changeTab} label="Summary" hasContent={true} error={tabErrors?.summary} />
                        {userContext.hasPermission('campaigns.panel_bookings') &&
                            <TabStatus value="panel-bookings" changeTab={changeTab} label="Panel Bookings" hasContent={!!values?.panelBookings} error={tabErrors?.panelBookings} />
                        }
                        {userContext.hasPermission('digitalbookings.view') &&
                            <TabStatus value="digital-bookings" changeTab={changeTab} label="Digital Bookings" hasContent={!!values?.digitalBookings} error={tabErrors?.DigitalBookings} />
                        }
                        <TabStatus value="area-bookings" changeTab={changeTab} label="Area Bookings" hasContent={values?.areaBookings && values.areaBookings.length} error={tabErrors?.areaBookings} />
                        {tabs}
                        {userContext.hasPermission('campaigns.media_production') &&
                            <TabStatus value="media-productions" changeTab={changeTab} hasContent={values?.mediaProductions && values.mediaProductions.length} error={tabErrors?.mediaProductions} label='Media Production' />
                        }
                        {userContext.hasPermission('campaigns.other') &&
                            <TabStatus value="sundries" changeTab={changeTab} hasContent={values?.sundries && values.sundries.length} error={tabErrors?.sundries} label='Other' />
                        }
                        <TabStatus value="portfolio" changeTab={changeTab} hasContent={true} error={tabErrors?.portfolio} label="Proposal" />
                        {(userContext.hasPermission('campaigns.costs') || userContext.hasPermission('campaigns.costs_view')) &&
                            <TabStatus value="costs" changeTab={changeTab} hasContent={values?.costs && values.costs.length} error={tabErrors?.costs} label='Costs' />
                        }
                        {!isNew &&
                            <TabStatus value="changes" changeTab={changeTab} hasContent={true} error={tabErrors?.changes} label="Changes" />
                        }
                    </Tabs>
                </Box>
                <Outlet context={contextValue} />

            </ExchangeRatesContextProvider>
        </div>
    );
}
